export default __webpack_public_path__ + "static/media/logo-1.1f952a59.webp";